import PercentInfo from './PercentInfo';
export default PercentInfo;
